import { fetchWithTimeout } from "@/utils";
export const fetchPrefillData = async (prefillUrl, jwt) => {
    try {
        const response = await fetchWithTimeout(prefillUrl, {
            method: "GET",
            mode: "cors",
            credentials: "same-origin",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${jwt}`,
            },
        }, 2000);
        if (!response.ok) {
            return null;
        }
        return response.json();
    }
    catch (error) {
        return null;
    }
};
